import { createApiV2 } from "../common";

// The signed-in person's own Planner settings, defaults filled in; `chosen` names the ones they saved.
export const getPersonalSettings = () => (token) => createApiV2("GET", "planner/settings/")(token);

// One setting per request, so a second open tab cannot overwrite the others.
export const putPersonalSetting = (key, value) => (token) =>
  createApiV2("PUT", `planner/settings/${key}/`)(token, { value });
